//---flask------------------------------------------:
export const createFlask = data => {
  //data = {id, solution}
  return { type: "CREATE_FLASK", payload: data };
};

export const setFlask = data => {
  //data = {id, solution}
  return { type: "SET_FLASK", payload: data };
};

export const incFlask = data => {
  //data = {id, solution}
  return { type: "INC_FLASK", payload: data };
};

export const decFlask = data => {
  //data = {id, open}
  return { type: "DEC_FLASK", payload: data };
};

export const isPouring = data => {
  //data = {id, pour}
  return { type: "SET_FLASK_POUR", payload: data };
};

export const setFlaskHeld = data => {
  //data = {id, held}
  return { type: "SET_FLASK_HELD", payload: data };
};

//Set whether the flask controls are displayed or not
export const setFlaskControlVisibility = (data) => {
  //data = {id, animatingOut}
  return { type: "SET_FLASK_CONTROLS_VISIBLE", payload: data}
}


export const setDigestPrediction = (data) => {
    //data = {id, prediction}
    return { type: "SET_DIGEST_PREDICTION", payload: data}
}

export const hideAllControls = (data) => {
  return { type: "HIDE_ALL_CONTROLS", payload: {controlsVisible: false} }
}